import { StatusDotProps, Tone } from './props.js'

export function StatusDot({
  tone,
  label,
  muted = true,
  className = '',
}: StatusDotProps) {
  // Map tones to background colors for the dot
  const toneColorMap: Record<Tone, string> = {
    neutral: 'bg-on-surface-subtle',
    primary: 'bg-primary',
    secondary: 'bg-on-surface-variant',
    success: 'bg-success',
    error: 'bg-error',
    warning: 'bg-warning',
    info: 'bg-info',
    violet: 'bg-violet',
    teal: 'bg-teal',
  }

  const bgColor = toneColorMap[tone] ?? toneColorMap['neutral']!
  const textClass = muted ? 'text-on-surface-variant' : 'text-on-surface'

  return (
    <div className={`inline-flex items-center gap-2 whitespace-nowrap ${className}`}>
      <div className={`h-1.5 w-1.5 rounded-full ${bgColor}`} />
      <span className={`text-body-sm ${textClass}`}>{label}</span>
    </div>
  )
}
